module.exports = __webpack_public_path__ + "static/media/pin_buckle_dlc.3747d744.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin_buckle_dlc.png
// module id = 110
// module chunks = 0